export default "__VITE_ASSET__CNXQzkvM__"